import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { ImageContainerBlockProps } from './type';

interface CreateProps {
  key: string;
  label: string;
  location: IBlockLocation;
  mappingKey?: string;
  width?: number;
  height?: number;
  imageWidth?: number;
  imageHeight?: number;
  gap?: number;
  direction?: 'row' | 'column';
  maxImages?: number;
}

export const createImageContainerBlock = (
  props: CreateProps,
): ImageContainerBlockProps => ({
  type: 'image_container',
  isVisible: false,
  x: 0,
  y: 0,
  width: 400,
  height: 80,
  imageWidth: 70,
  imageHeight: 70,
  gap: 4,
  direction: 'row',
  mappingKey: 'images',
  images: [],
  ...props,
});

export function isImageContainerBlock(
  block: BlockProps,
): block is ImageContainerBlockProps {
  return block.type === 'image_container';
}
